// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_landing__Api from "../../../../core/Api.js";
import * as Buhta_landing__Content from "../../../../core/Content.js";
import * as Buhta_landing__Route from "../../../../Route.js";
import * as Buhta_models__Locale from "../../../../../../../packages/models/Locale.js";
import * as MelNumeral from "../../../../../../../packages/util/lib/MelNumeral.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function Prices(Props) {
  const country = Buhta_landing__Route.getCountry(undefined);
  const countryStr = Buhta_models__Locale.toCountryString(country);
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const dispatchContent = match[1];
  const pricingCategories = match[0].pricingCategories;
  React.useEffect((function () {
    const __x = $$Promise.all({
      hd: Buhta_landing__Api.pricingCategories(countryStr),
      tl: /* [] */ 0
    });
    $$Promise.get(__x, (function (respList) {
      Stdlib__List.iter((function (res) {
        Buhta_landing__Api.handleResponse(res, dispatchContent, undefined);
      }), respList);
    }));
  }), [countryStr]);
  return Belt__Belt_List.toArray(Stdlib__List.mapi((function (index, i) {
    const Key = "pricing_item_" + String(index);
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("img", {
                className: "max-w-none",
                alt: "buhta",
                src: i.icon
              })
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h6", {
                  children: i.name,
                  className: "h6 text-black-landing"
                }),
                JsxRuntime.jsx("p", {
                  children: i.description,
                  className: "paragraph text-gray-landing"
                })
              ],
              className: "mt-4 lg:mt-0 lg:ml-4"
            })
          ],
          className: "block lg:flex items-center mb-6 lg:mb-10"
        }),
        Belt__Belt_List.toArray(Stdlib__List.mapi((function (index, p) {
          const Key = "item_price_" + String(index);
          const pr = p.prefix;
          const price = p.price;
          const period = p.period;
          return JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: p.name,
                    className: "paragraph-small lg:paragraph text-black-landing"
                  }),
                  JsxRuntime.jsx("p", {
                    children: Belt__Belt_Option.getWithDefault(p.description, ""),
                    className: "paragraph-small lg:paragraph text-gray-landing"
                  })
                ]
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("p", {
                    children: [
                      pr !== undefined ? pr + " " : null,
                      price !== undefined ? MelNumeral.format({
                          NAME: "Int",
                          VAL: price
                        }) + (" " + Belt__Belt_Option.getWithDefault(p.currency, "₸")) : null
                    ],
                    className: "paragraph-small lg:paragraph text-success"
                  }),
                  period !== undefined ? JsxRuntime.jsx("p", {
                      children: "/" + period,
                      className: "paragraph-small lg:paragraph opacity-64 text-success ml-2"
                    }) : null
                ],
                className: "flex shrink-0"
              })
            ],
            className: "flex justify-between mt-3"
          }, Key);
        }), i.prices))
      ],
      className: "bg-white rounded-lg p-6 lg:p-9 mt-4 shadow-price"
    }, Key);
  }), pricingCategories));
}

const make = Prices;

export {
  make,
}
/* Buhta_landing__Api Not a pure module */
